import React from 'react';
import useStyles from './styles';
import { useTranslation } from 'react-i18next';
import blockchain_logo from 'src/assets/blockchain_logo.png';
import smartcontract_logo from 'src/assets/smartcontract_logo.png';
import token_logo from 'src/assets/token_logo.png';
import modal_blockchain from 'src/assets/modal_blockchain.png';
import modal_smartcontract from 'src/assets/modal_smartcontract.png';
import modal_token from 'src/assets/modal_token.png';
import { useModalStore } from 'src/store/useModalStore';


const BlogsComponent: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { openModal } = useModalStore();

  const cards = [
    {
      image: blockchain_logo,
      title: t('BLOCKCHAIN_TITLE'),
      description: t('BLOCKCHAIN_DESCRIPTION'),
      modalImage: modal_blockchain,
      modalTitle: t('BLOCKCHAIN_MODAL_TITLE'),
      modalDescription: t('BLOCKCHAIN_MODAL_DESCRIPTION'),
      modalLargeText: t('BLOCKCHAIN_MODAL_LARGE_TEXT')
    },
    {
      image: smartcontract_logo,
      title: t('SMARTCONTRACT_TITLE'),
      description: t('SMARTCONTRACT_DESCRIPTION'),
      modalImage: modal_smartcontract,
      modalTitle: t('SMARTCONTRACT_MODAL_TITLE'),
      modalDescription: t('SMARTCONTRACT_MODAL_DESCRIPTION'),
      modalLargeText: t('SMARTCONTRACT_MODAL_LARGE_TEXT')
    },
    {
      image: token_logo,
      title: t('TOKEN_TITLE'),
      description: t('TOKEN_DESCRIPTION'),
      modalImage: modal_token,
      modalTitle: t('TOKEN_MODAL_TITLE'),
      modalDescription: t('TOKEN_MODAL_DESCRIPTION'),
      modalLargeText: t('TOKEN_MODAL_LARGE_TEXT')
    },
  ];

  return (
    <div className={classes.blogsContainer}>
      <div className={classes.cardsContainer}>
        {cards.map((card, index) => (
          <div key={index} className={classes.card}>
            <img
              src={card.image}
              alt={card.title}
              className={classes.cardImage}
            />

            <h3 className={classes.cardTitle}>{card.title}</h3>
            <p className={classes.cardDescription}>{card.description}</p>
            {<button
              className={classes.showMoreButton}
              onClick={() =>
                openModal(card.modalTitle, card.modalImage, card.modalDescription, card.modalLargeText)
              }
            >
              {t('SHOW_MORE')}
            </button>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogsComponent;
